function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PER_PAGE_OPTIONS } from '@keen.io/ui-core';
import chartTransformations from '../charts';
import { createWidgetSettings } from '../utils';
import { AvailableIcons } from '../constants';

var serializeInputSettings = function serializeInputSettings(widgetType, chartSettings, widgetSettings) {
  var settings = null;

  switch (widgetType) {
    case 'heatmap':
      settings = {
        chart: chartTransformations.heatmap.serializeIn(chartSettings),
        widget: createWidgetSettings(widgetSettings)
      };
      break;

    case 'choropleth':
      settings = {
        chart: chartTransformations.choropleth.serializeIn(chartSettings),
        widget: createWidgetSettings(widgetSettings)
      };
      break;

    case 'donut':
    case 'pie':
      settings = {
        chart: chartTransformations.circular.serializeIn(chartSettings),
        widget: createWidgetSettings(widgetSettings)
      };
      break;

    case 'funnel':
      settings = {
        chart: chartTransformations.funnel.serializeIn(chartSettings),
        widget: createWidgetSettings(widgetSettings)
      };
      break;

    case 'metric':
      settings = {
        chart: chartTransformations.metric.serializeIn(chartSettings),
        widget: createWidgetSettings(widgetSettings)
      };
      break;

    case 'line':
    case 'area':
      settings = {
        chart: chartTransformations.line.serializeIn(chartSettings),
        widget: createWidgetSettings(widgetSettings)
      };
      break;

    case 'bar':
      settings = {
        chart: chartTransformations.bar.serializeIn(chartSettings),
        widget: createWidgetSettings(widgetSettings)
      };
      break;

    case 'table':
      settings = {
        chart: chartTransformations.table.serializeIn(chartSettings),
        widget: createWidgetSettings(widgetSettings)
      };
      break;

    case 'gauge':
      settings = {
        chart: chartTransformations.gauge.serializeIn(chartSettings),
        widget: createWidgetSettings(widgetSettings)
      };
      break;

    default:
      settings = {
        chart: {
          formatValue: null,
          funnelPercentages: chartSettings.theme.funnel.header.badge.enabled,
          verticalGrid: chartSettings.theme.gridX.enabled,
          horizontalGrid: chartSettings.theme.gridY.enabled,
          valueMode: chartSettings.valueMode
        },
        widget: createWidgetSettings(widgetSettings)
      };
  }

  return {
    chart: _objectSpread({
      formatTableColumns: {},
      columnsNamesMapping: {},
      iconEnabled: false,
      iconStyle: 'solid',
      iconType: AvailableIcons[0],
      pagination: true,
      rowsPerPage: PER_PAGE_OPTIONS[3]
    }, settings.chart),
    widget: settings.widget
  };
};

export default serializeInputSettings;